module.exports = __webpack_public_path__ + "media/images/emoticons/hotel-1b845f5e605414aaabf055df8beb61b7.gif";